import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-event-streaming',
  templateUrl: 'event-streaming.html',
})
export class EventStreaming {

  event: any;
  client: string;
  dataStreaming: any = false;

  constructor(public navCtrl: NavController, public params: NavParams) {
    this.event = this.params.get('event');
    this.client = this.params.get('client');
    this.dataStreaming = this.params.get('dataStreaming');
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-streaming/event-streaming.ts